var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLightbulbWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 25,
    viewBox: "0 0 17 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.216 18.324C12.6741 16.8017 13.6237 15.5038 14.5637 14.2106C14.8119 13.8718 15.06 13.533 15.2986 13.1894C16.2434 11.8295 16.797 10.1832 16.797 8.40326C16.797 3.76023 13.0367 0 8.39849 0C3.76023 0 0 3.76023 0 8.39849C0 10.1784 0.553537 11.8295 1.49837 13.1847C1.73696 13.5282 1.9851 13.867 2.23323 14.2058C3.17806 15.499 4.12767 16.8017 4.58099 18.3192H12.216V18.324ZM8.39849 24.432C10.5077 24.432 12.216 22.7236 12.216 20.6145V19.851H4.58099V20.6145C4.58099 22.7236 6.28932 24.432 8.39849 24.432ZM4.58099 8.39849C4.58099 8.81841 4.23742 9.16199 3.81749 9.16199C3.39757 9.16199 3.054 8.81841 3.054 8.39849C3.054 5.4447 5.4447 3.054 8.39849 3.054C8.81841 3.054 9.16199 3.39757 9.16199 3.81749C9.16199 4.23742 8.81841 4.58099 8.39849 4.58099C6.28932 4.58099 4.58099 6.28932 4.58099 8.39849Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLightbulbWhite);
export default __webpack_public_path__ + "static/media/ic_lightbulb_white.4fe99c4b839b4eea37c67b83eb28e832.svg";
export { ForwardRef as ReactComponent };